import h from 'snabbdom/h';
import { filter, map } from 'ramda';
import annotation, { getAnnotationProperties } from './annotation';
import { isSceneRendered } from '../modules/sceneIO';
import { getCustomAnnotationFunction } from '../modules/annotations';

const attachTranslator = function (store, translator) {
  return (info) => {
    translator.attach(info.elm);

    function onResize() {
      translator.resize();
    }

    window.addEventListener('resize', onResize);
  };
};

function ignoreRightClick(ev) {
  ev.preventDefault();
};

export default function canvas(store) {
  const translator = store.getTranslator();
  const rendered = isSceneRendered(store);

  translator.update();

  const annotationFn = getCustomAnnotationFunction(store);

  const annotations = filter((a) => !!a, map((obj) => getAnnotationProperties(store, obj),
      Object.values(translator.getAnnotations())));

  function callCustomAnnotationFn(vnode) {
    annotations.forEach((annotation) => annotationFn(annotation, vnode.elm));
  }

  const children = annotationFn ? [h('div.annotations', {
    style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, pointerEvents: 'none' },
    hook: {
      insert: callCustomAnnotationFn,
      update: callCustomAnnotationFn,
    },
  }),] : map(annotation(store), annotations);

  return h('div', {
    style: { position: 'relative', display: (rendered ? 'block' : 'none') },
    on: { contextmenu: ignoreRightClick },
    hook: { insert: attachTranslator(store, translator) },
  }, children);
};



// WEBPACK FOOTER //
// ./src/components/canvas.js